export default "__VITE_ASSET__e24ff88e__"